
<!--

<form [formGroup]="myform" (ngSubmit)="onSubmit()" >
  <div class='form-control' >
    <label for='username' >Username</label>
    <input  type='text' class='form-control' formControlName='username' >
  </div>
  <div class='form-control' >
    <label for='password' >Password</label>
    <input type='password' formControlName='password' >
  </div>
  <button type='submit' >Logn</button>
</form>

-->
<app-header [logged]="false"  ></app-header>

  <div class="container" >
    <div class="row mt-5">
      <div class="col-6">
        <img class="img-fluid" src="assets/blog_home.png" >
      </div>
      <div class="col-6 p-5">
        <div class="login-container mt-5 mb-5 pb-5">
          <div class="login-content">
            <div>
              <h1>Sign Up !!</h1>
              <form [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit()">
                <mat-form-field>
                  <input autofocus type="text" matInput placeholder="Username" formControlName="username">
                </mat-form-field>
        
                <mat-form-field>
                  <input type="password" autocomplete="false" matInput placeholder="Password" formControlName="password">
                </mat-form-field>
        
                <button type="submit" mat-raised-button style="background-color: rgba(255, 136, 0, 0.856); color: white;">Login</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<div  style="margin-top: 120px;">
  <app-footer  ></app-footer>
</div>
